/**
 * Import styles
 */

import './styles/main.scss';

/**
 * Javascript files
 */

import './js/router';
import './js/media-query';
import './js/contact-form';


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = lVK7
// module chunks = 0